export enum SubscribeStatus {
  BAD_REQUEST = "bad-request",
  TOKEN_INVALID = "token-invalid",
  TOKEN_MISSING = "token-missing",
  INTERNAL_SERVER_ERROR = "internal-server-error",
  SUCCESS = "success",
  USER_ALREADY_EXISTS = "user-already-exists",
}
